import styled from 'styled-components';

export const QrLinkContainer = styled.div<{ isCustomPartner?: boolean }>`
    display: flex;
    min-width: 424px;
    min-height: 120px;
    padding: ${(props) => (props.isCustomPartner ? '20px 16px 12px 20px' : '16px 20px')};
    border-radius: 8px;
    background-color: ${(props) => props.theme.palette.secondaryA10};

    .qr-link__title {
        ${(props) => {
            if (props.isCustomPartner) {
                return {
                    marginTop: '-8px',
                    marginBottom: 0,
                };
            }

            return {
                marginBottom: '12px',
                marginTop: '8px',
            };
        }}
    }

    .qr-link__text {
        color: ${(props) => props.theme.palette.textLight};

        a {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }

    .qr-code {
        margin-right: ${(props) => (props.isCustomPartner ? '16px' : '20px')};
        min-height: 80px;
        min-width: 80px;

        img {
            height: 100%;
        }
    }

    .button-close {
        position: absolute;
        top: 16px;
        right: 16px;
    }
`;
